import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from './config.service';


@Injectable({
  providedIn: 'root'
})
export class RegisterPackageService {
  configService = null;

  constructor(private http: HttpClient) {
    this.configService = new ConfigService();
  }

  searchUser(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/searchUserByValue'), data, { headers });
  }

  searchUserSender(data,agencyId) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    let params = new HttpParams();
    params = params.append('value', data.value);
    if(agencyId){
      params = params.append('agencyId', agencyId);
    }
    return this.http.get(this.configService.serverIp.concat('/searchSenderByAgency'), { params, headers });
  }
  searchUserReceiver(data,agencyId) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    let params = new HttpParams();
    params = params.append('value', data.value);
    if(agencyId){
      params = params.append('agencyId', agencyId);
    }
    return this.http.get(this.configService.serverIp.concat('/searchReceiptByAgency'), { params, headers });
  }
  getCarriers() {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/registerPackage'), { headers });
  }

  getPreAlertedPackage(trackingData) {
    const params = new HttpParams()
      .set('tracking', trackingData.tracking)
      .set('id_carrier', trackingData.carrierId);
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/preAlertByTracking'), { params, headers });
  }

  searchContainer(guide) {
    let data = { guide: guide };
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/searchContainer'), data, { headers });
  }

  /*registerArrivedPackage(data) {//<-- No se usa
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/registerPackagesByGuide'), data, {headers});
  }*/

  registerWarehousePackage(data, isNotPrealertedPackage) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    if (isNotPrealertedPackage && (!data.get('id_user_package') || data.get('id_user_package') == 'undefined')) {
      return this.http.post(this.configService.serverIp.concat('/registerPackageWithoutPreAlert'), data, { headers });
    } else if (isNotPrealertedPackage && data.get('id_user_package')) {
      return this.http.post(this.configService.serverIp.concat('/registerPackageWithoutPreAlertWithUser'), data, { headers });
    } else {
      return this.http.post(this.configService.serverIp.concat('/registerPackage'), data, { headers });
    }

  }

  registerGuide(nguide) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/registerGuideInMaster'),
      { 'guide': nguide }, { headers });
  }

  registerContainer(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/registerContainer'), data, { headers });
  }

  searchUserFrequent(id) {
    const params = new HttpParams()
      .set('user_id', id)
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/getFrequentShippingsFromUser'), { params, headers });
  }

  registerTrackingWarehouse(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/registerTrackingWarehouse'), data, { headers });
  }
  
  reportTrackingWarehouse(data){
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/reportTrackingWarehouse'), data, { headers });
  }

  findTrackingWarehouse(data){
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/findTrackingWarehouse'), data, { headers });
  }
}
